import { CallAPI } from "../utils/api";

export async function AddCheque(payload) {
  return CallAPI(
    `/addCheque`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
    true
  );
}

export async function GetCheques(date) {
  return CallAPI(
    `/getCheques/${date}`,
    {
      method: "GET",
    },
    true
  );
}

export async function UpdateChequeStage(id, field, date) {
  const data = {
    field: field,
    date: date,
  };  
  return CallAPI(
    `/updateChequeStage/${id}`,
    {
      method: "PATCH",
      body: JSON.stringify(data),
    },
    true
  );
}

export async function DeleteCheque(id) {
  return CallAPI(
    `/deleteCheque/${id}`,
    {
      method: "DELETE",
    },
    true
  );
}


export async function EditCheque(id, payload) {
  return CallAPI(
    `/editCheque/${id}`,
    {
      method: "PATCH",
      body: JSON.stringify(payload),
    },
    true
  );
}

